module.exports = __webpack_public_path__ + "img/flower.0482c264.png";